type ReloadGuard = {
  hasAttempted: () => boolean;
  markAttempted: () => void;
  clearAttempted: () => void;
};

const readSessionFlag = (key: string): string | null => {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeSessionFlag = (key: string, value: string | null) => {
  try {
    if (value === null) {
      window.sessionStorage.removeItem(key);
      return;
    }
    window.sessionStorage.setItem(key, value);
  } catch {
    // Storage can be blocked in strict privacy contexts.
  }
};

const updateUrlFlag = (queryKey: string, enabled: boolean) => {
  try {
    const url = new URL(window.location.href);
    if (enabled) {
      url.searchParams.set(queryKey, "1");
    } else {
      url.searchParams.delete(queryKey);
    }

    const nextUrl = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(window.history.state, document.title, nextUrl);
  } catch {
    // URL/history updates are best-effort only.
  }
};

export const createReloadGuard = (storageKey: string, queryKey: string): ReloadGuard => {
  const hasAttempted = () => {
    if (typeof window === "undefined") return false;
    if (readSessionFlag(storageKey) === "1") return true;

    try {
      return new URL(window.location.href).searchParams.has(queryKey);
    } catch {
      return false;
    }
  };

  const markAttempted = () => {
    if (typeof window === "undefined") return;
    writeSessionFlag(storageKey, "1");
    updateUrlFlag(queryKey, true);
  };

  const clearAttempted = () => {
    if (typeof window === "undefined") return;
    writeSessionFlag(storageKey, null);
    updateUrlFlag(queryKey, false);
  };

  return { hasAttempted, markAttempted, clearAttempted };
};
